/**
 * Registration fixture values for the mocked F01 implementation.
 *
 * Magic email values that drive mock scenarios in the register action and are
 * shared with Playwright E2E tests.
 *
 * DH_MARKETS is the authoritative list of Delivery Hero operating countries
 * for the mock. Replace with a BFF-served list when the real API is wired up.
 *
 * No Vite or browser-specific APIs — importable from both the route action
 * (server context) and Playwright test files (Node.js context).
 */
export const REGISTER_FIXTURES = {
  emails: {
    /** Email that triggers the duplicate-account mock scenario. */
    duplicate: "existing@company.com",
    /** Email that triggers the VBO failure (502) mock scenario. */
    vboFailure: "vbo-failure@company.com",
  },
  /** Convenience values for filling the registration form in E2E tests. */
  validForm: {
    firstName: "Jane",
    lastName: "Smith",
    email: "jane.smith@company.com",
    phone: "+1 555 123 4567",
    company: "Acme Corp",
    website: "https://acme.com",
    vendors: "1-10",
    pgpKey: "-----BEGIN PGP PUBLIC KEY BLOCK-----\nmockpgpkey\n-----END PGP PUBLIC KEY BLOCK-----",
    market: "DE", // single market value used in E2E option selection
  },
} as const;

/** Delivery Hero operating markets — sourced from deliveryhero.com/brands-countries/. */
export const DH_MARKETS = [
  { value: "BH", label: "Bahrain" },
  { value: "DK", label: "Denmark" },
  { value: "EG", label: "Egypt" },
  { value: "FI", label: "Finland" },
  { value: "DE", label: "Germany" },
  { value: "GR", label: "Greece" },
  { value: "HK", label: "Hong Kong" },
  { value: "IQ", label: "Iraq" },
  { value: "JO", label: "Jordan" },
  { value: "KW", label: "Kuwait" },
  { value: "LB", label: "Lebanon" },
  { value: "MA", label: "Morocco" },
  { value: "NO", label: "Norway" },
  { value: "PH", label: "Philippines" },
  { value: "PK", label: "Pakistan" },
  { value: "RO", label: "Romania" },
  { value: "SA", label: "Saudi Arabia" },
  { value: "SG", label: "Singapore" },
  { value: "SE", label: "Sweden" },
  { value: "TW", label: "Taiwan" },
  { value: "TH", label: "Thailand" },
  { value: "TN", label: "Tunisia" },
  { value: "TR", label: "Turkey" },
  { value: "AE", label: "United Arab Emirates" },
] as const;

export type MarketValue = (typeof DH_MARKETS)[number]["value"];
